module.exports = __webpack_public_path__ + "img/trash.e4a3514e.png";